module.exports = __webpack_public_path__ + "img/letter.2fda5bbc.png";